var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCirclePlus = function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.39 4.75v3.958h3.996v1.584H10.39v3.958H8.792v-3.958H4.795V8.708h3.997V4.75h1.598zm-.8 12.667c4.408 0 7.993-3.551 7.993-7.917 0-4.365-3.585-7.917-7.992-7.917S1.598 5.135 1.598 9.5c0 4.366 3.586 7.917 7.993 7.917zM9.59 0c5.29 0 9.592 4.262 9.592 9.5S14.879 19 9.59 19C4.302 19 0 14.738 0 9.5S4.302 0 9.59 0z"
  })));
};

export default SvgCirclePlus;